import localeData from "./locales";

const defaultLocale =
  (navigator.languages && navigator.languages[0]) || navigator.language || navigator.userLanguage || "en";

const languageWithoutRegionCode = defaultLocale.toLowerCase().split(/[_-]+/)[0];

const getMessages = locale => {
  return localeData[locale] || localeData[languageWithoutRegionCode] || localeData[defaultLocale];
};

export { defaultLocale, getMessages };
